import { render, staticRenderFns } from "./prePrescriptRegistModal.vue?vue&type=template&id=92bd332c"
import script from "./prePrescriptRegistModal.vue?vue&type=script&lang=js"
export * from "./prePrescriptRegistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports